import { jsx as _jsx } from "react/jsx-runtime";
import { MantineProvider as MantineProviderCore, createTheme } from '@mantine/core';
// Create a custom theme for labeling tools
const labelingToolsTheme = createTheme({
    primaryColor: 'blue',
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    components: {
        Button: {
            defaultProps: {
                size: 'sm',
            },
        },
    },
});
export const MantineProvider = ({ children, theme = labelingToolsTheme }) => {
    return (_jsx(MantineProviderCore, { theme: theme, children: children }));
};
